import { Box, Typography, Stack } from "@mui/material";
import MzButton from "@markaaz/ui/MzButton";
import MzAlert from "@markaaz/ui/MzAlert";
import MzDataGrid from "@markaaz/ui/MzDataGrid";

const sx = {
  dataGrid: (theme) => {
    return {
      "& .MuiDataGrid-virtualScroller": {
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "10px",
          height: "10px",
          backgroundColor: theme.palette.common.white,
          borderRadius: "0px 0px 8px 8px"
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: theme.palette.darkBlue.c20,
          borderRadius: "8px"
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "none",
          borderRadius: "0px"
        }
      },
      "& .MuiDataGrid-cell": {
        paddingLeft: "20px"
      },
      "& .MuiDataGrid-columnHeader": {
        paddingLeft: "20px"
      }
    };
  }
};

export default function DataFieldTable({
  rows,
  fieldMappingRows,
  isError,
  mappedDataLoading,
  loadData,
  onShow,
  onAlertClose
}) {
  const columns = fieldMappingRows.map((field) => {
    return {
      field: field.fieldName,
      headerName: (
        <div>
          {field.fieldOrder && <div>{field.fieldOrder}</div>}
          <div>{field.fieldName}</div>
        </div>
      ),
      width: 210,
      sortable: false
    };
  });

  return (
    <Box>
      <Typography variant="h6" mb={2} mt={10}>
        Map Fields
      </Typography>
      <Typography variant="body2" mb={2} maxWidth={750}>
        Map fields based on saved mapping to confirm the data output aligns with the configuration settings. This will
        provide visual output of one record in the file showing the data from the file appearing in the mapped column.
      </Typography>
      <Stack direction="row" gap={10} alignItems="center">
        <MzButton sx={{ my: 4 }} size="large" loading={mappedDataLoading} variant="contained" onClick={onShow}>
          Show Mapped Data
        </MzButton>
        <Box>
          {isError && (
            <MzAlert
              sx={{ alignItems: "center", maxWidth: "400px" }}
              severity="error"
              onClose={() => {
                onAlertClose("smd");
              }}
            >
              Unable to show mapped data, please upload a <br /> test file first.
            </MzAlert>
          )}
        </Box>
      </Stack>

      <Box>
        {rows && loadData && (
          <MzDataGrid
            sx={sx.dataGrid}
            variant="3"
            rowHeight={75}
            autoHeight
            rows={rows}
            columns={columns}
            disableSelectionOnClick
            disableColumnMenu={true}
            getRowId={(row) => row?.["Company Legal Name"] ?? ""}
            hideFooterPagination
          />
        )}
      </Box>
    </Box>
  );
}
